/**
 * NewsCenterTemplate — variação `newsCenter` do bloco Listing nativo.
 *
 * Página "News Center" (/{lang}/noticias, Proposta Layout 03-web.png +
 * 02-mobile-3.png): lista vertical de cards (imagem + título +
 * data + resumo), sem badge de categoria nem tags — decisão 2026-09-04, ver
 * docs/specs/blocks/news-listing-page.md §2. O badge dourado "NEWS" do
 * mockup também não entra — decisão 2026-09-08 (Rodrigo): mesmo grupo dos
 * chips de tag que já tínhamos combinado deixar de fora nesta versão.
 *
 * O título da página vem do bloco `title` nativo do Volto, não daqui — até
 * 2026-09-08 era uma string fixa de i18n ("News Center"), que além de
 * duplicar o título do próprio documento não era editável pelo CMS.
 * A paginação é renderizada pelo ListingBody (sombreado) usando
 * NewsPagination, não por este template.
 */
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import FormattedDate from '@plone/volto/components/theme/FormattedDate/FormattedDate';

type ListingItem = {
  '@id': string;
  title?: string;
  id?: string;
  description?: string;
  effective?: string;
  [key: string]: unknown;
};

// O PreviewImage do core monta o `srcSet` com todas as escalas do Plone, mas
// não emite `sizes` — sem ele o navegador assume 100vw e baixa a escala do
// tamanho da janela (1600w para um card de 280px). Larguras de _news-center.scss.
const CARD_SIZES = '(max-width: 768px) 100vw, 280px';

export type NewsCenterTemplateProps = {
  items: ListingItem[];
  isEditMode?: boolean;
};

const NewsCenterTemplate = ({ items, isEditMode }: NewsCenterTemplateProps) => {
  return (
    <>
      <ul className="news-center__list">
        {items.map((item) => (
          <li className="news-center__card" key={item['@id']}>
            <ConditionalLink item={item} condition={!isEditMode}>
              <div className="news-center__media">
                <Component
                  componentName="PreviewImage"
                  item={item}
                  alt=""
                  loading="lazy"
                  sizes={CARD_SIZES}
                />
              </div>
              <div className="news-center__content">
                <h3 className="news-center__title">{item.title || item.id}</h3>
                {item.effective && (
                  <p className="news-center__date">
                    <FormattedDate date={item.effective} />
                  </p>
                )}
                {item.description && (
                  <p className="news-center__excerpt">{item.description}</p>
                )}
              </div>
            </ConditionalLink>
          </li>
        ))}
      </ul>
    </>
  );
};

export default NewsCenterTemplate;
